import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-upload-sub-videos-tab',
  templateUrl: './upload-sub-videos-tab.component.html',
  styleUrls: ['./upload-sub-videos-tab.component.scss']
})
export class UploadSubVideosTabComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
